type StatusColor = 'info' | 'warning' | 'success' | 'error' | 'default';

export function getStatusColor(status: string | undefined | null): StatusColor {
  if (!status) return 'default';
  const s = status.toLowerCase().trim();

  // Map known statuses to semantic colors
  if (s.includes('open') || s.includes('new')) return 'info';
  if (s.includes('progress') || s.includes('pending') || s.includes('active')) return 'warning';
  if (s.includes('closed') || s.includes('resolved') || s.includes('complete')) return 'success';
  if (s.includes('cancel') || s.includes('rejected') || s.includes('failed')) return 'error';
  if (s.includes('hold') || s.includes('wait') || s.includes('paused')) return 'default';

  return 'default';
}
